import axios, { AxiosResponse, AxiosError } from "axios";
import { ApiResponse } from "../types/api";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const tokenManager = {
  getToken: (): string | null => {
    return localStorage.getItem("accessToken");
  },

  setToken: (token: string): void => {
    localStorage.setItem("accessToken", token);
  },

  removeToken: (): void => {
    localStorage.removeItem("accessToken");
  },
};

apiClient.interceptors.request.use(
  (config) => {
    const token = tokenManager.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiClient.interceptors.response.use(
  (response: AxiosResponse<ApiResponse>) => {
    return response;
  },
  (error: AxiosError<ApiResponse>) => {
    const isLoginEndpoint = error.config?.url?.includes("/auth/login");
    if (error.response?.status === 401 && !isLoginEndpoint) {
      tokenManager.removeToken();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  },
);

export default apiClient;
